import * as z from "zod";

export const createTemplateBodySchema = z
  .object({ id: z.number() })
  .nonstrict();
